<template>
  <div class="body">
        <p  class="font1" style="padding-top: 8vh;">默默耕耘，铸就辉煌</p>
        <p class="font2" style="padding-top: 5vh;">2025上半年你的个人发展与成长：</p>
        <p class="font2" v-if="course!==''"> <i class="fa fa-check"></i>完成了<a class="font3">{{ this.course }}</a></p>
        <p class="font2" v-if="promote!==''"> <i class="fa fa-check"></i>顺利晋升为<a class="font3">{{ this.promote }}</a></p>
        <p class="font2" v-if="teacher!==''"> <i class="fa fa-check"></i>通过讲师认证，成为<a class="font3">{{ this.teacher }}</a></p>         
        <p class="font2" style="padding-top: 4vh;margin: 0;">每一次培训与认证</p>
        <p class="font2" style="margin: 0;">都是你专业成长的阶梯</p>
        <p class="font2" style="margin: 0;">每一份坚持</p>
        <p class="font2" style="margin: 0;">都是通往未来成功的基石</p>
        <p class="font2" style="margin: 0;">继续学习，你的前途将更加光明～</p>
  </div>
</template>

<script>
export default {
    props:['ReportData'],
    data(){
        return {
            activityArray:[],
            course:'',
            promote:'',
            teacher:'',
        }
    },
    created() {
        this.parseActivity();
    },
    methods: {
        parseActivity() {
            try {
                const obj = this.ReportData.activity2

                // 遍历数组中的每个对象
                obj.forEach(item => {
                    if (item["鸿鹄培训项目"]) {
                        this.course = item["鸿鹄培训项目"];
                    }

                    if (item["认证培训项目"]) {
                        this.certification = item["认证培训项目"];
                    }

                    if (item["晋升"]) {
                        this.promote = item["晋升"];
                    }

                    if (item["TTT培训项目"]) {
                        this.teacher = item["TTT培训项目"];
                    }
                });
                console.log( this.course, this.promote, this.teacher,obj,'123')
            } catch (e) {
                console.error("activity2 解析失败", e);
            }
        }
    }
}
</script>

<style scoped>
.body {
    background: 
        url("../../assets/25March/logo.png") right  top  no-repeat,
        url("../../assets/25June/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
	height: 100vh;
}
.font1 {
    width: 96%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #26a5e1;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font2 { 
    width: 96%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #000;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #64892f;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25June/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .font1{
    text-align: center;
  }
    .font2{
        font-size: 19px;
    }
}
</style>